import React from 'react'

const FILL = {
  on_time: '#12B76A',
  delay_0_3: '#F79009',
  delay_3_6: '#E67E22',
  delay_6_plus: '#F04438'
}

/**
 * US-DB-7 — timeliness of upcoming audit cycles vs their Next Cycle due
 * dates (AC-15). Real-time; no filter. Each bar shows percentage + count.
 */
export default function AuditScheduleDelays ({ data, loading }) {
  if (loading && !data) {
    return (
      <div className='dbv2-card'>
        <p className='dbv2-card-title'>Jadwal Audit</p>
        <div className='dbv2-loading'>Memuat…</div>
      </div>
    )
  }
  if (!data) return null

  const excluded = data.excluded || {}
  const hasExcluded = (excluded.realized > 0 || excluded.beyondWindow > 0)
  const windowMonths = excluded.windowMonths || 24
  const windowLabel = windowMonths % 12 === 0
    ? `${windowMonths / 12} tahun`
    : `${windowMonths} bulan`

  return (
    <div className='dbv2-card'>
      <p className='dbv2-card-title'>Next Cycle Performance</p>
      <p className='dbv2-card-subtitle'>
        Status realisasi vs due date (Next Cycle) ·{' '}
        <span
          className='dbv2-tip'
          data-tip={`Cakupan data: siklus audit dengan due date ${windowLabel} terakhir hingga mendatang. Siklus yang tertunda lebih lama dari itu dikeluarkan dari persentase (ditampilkan di catatan bawah).`}
        >
          cakupan data {windowLabel} terakhir
        </span>
      </p>
      {(data.categories || []).map((cat) => (
        <div className='dbv2-sched-row' key={cat.key}>
          <span className='dbv2-sched-label'>{cat.label}</span>
          <div className='dbv2-sched-track'>
            <div
              className='dbv2-sched-fill'
              style={{ width: `${cat.pct}%`, background: FILL[cat.key] || '#98A2B3' }}
            />
          </div>
          <span className='dbv2-sched-pct'>
            {cat.pct}% · {cat.count.toLocaleString('id-ID')}
          </span>
        </div>
      ))}
      { hasExcluded &&
        <p className='dbv2-card-subtitle' style={{ margin: '12px 0 0' }}>
          di luar perhitungan:{' '}
          { excluded.realized > 0 &&
            <span
              className='dbv2-tip'
              data-tip={`${excluded.realized.toLocaleString('id-ID')} siklus sudah punya order untuk fase tersebut — auditnya sudah berjalan/selesai, hanya baris rencananya yang belum ditutup, sehingga tidak adil dihitung terlambat`}
            >
              {excluded.realized.toLocaleString('id-ID')} siklus terealisasi
            </span>
          }
          { excluded.realized > 0 && excluded.beyondWindow > 0 && ' · ' }
          { excluded.beyondWindow > 0 &&
            <span
              className='dbv2-tip'
              data-tip={`${excluded.beyondWindow.toLocaleString('id-ID')} siklus belum terealisasi namun due date-nya sudah lewat lebih dari ${excluded.windowMonths} bulan — dianggap data rencana lama dan dikeluarkan dari persentase`}
            >
              {excluded.beyondWindow.toLocaleString('id-ID')} siklus lebih dari {excluded.windowMonths} bulan
            </span>
          }
        </p>
      }
    </div>
  )
}
